import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "w-screen h-screen flex flex-row flex-nowrap items-center justify-center gap-20" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: ""
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 3,
  class: "flex flex-col items-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "login to join", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.failed)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_2, "This invite isn't for you!"))
      : (_ctx.joining)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_3, "joining..."))
        : (_ctx.joined)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_4))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", {
                class: "p-cell rounded-note btn-primary",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
              }, "login")
            ]))
  ]))
}